import { AfterViewInit, Component, HostListener, Inject, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ConfirmationService } from 'primeng/primeng';
import { Setup } from './configuracoes/setup/setup.model';
import { SetupService } from './configuracoes/setup/setup.service';
import { EstoqueAuditoriaService } from './relatorios/rel-estoque-auditoria/estoque-auditoria.service';
import { AuthService } from './shared/auth/auth.service';
import { KEY_CODE } from './shared/constantes/key-codes';
import { GlobalsVariablesService } from './shared/service/global-variables.service';
import { MessageService } from './shared/service/message.service';
import { DOCUMENT } from '@angular/common';
import { environment } from '../environments/environment';
import { LayoutThemeService } from './shared/service/layout-theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: [
    './app.component.css',
    './app.responsive.css',
    '../styles/theme/neon-theme.css',
    '../styles/layout/neon-shell.css',
    '../styles/components/neon-list.css',
    '../styles/components/neon-detail.css',
    '../styles/components/neon-table.css',
    '../styles/components/neon-product-search.css',
    '../styles/components/neon-toast.css',
    '../styles/components/neon-dialog.css',
    '../styles/pages/neon-login.css',
    '../styles/pages/neon-favorecido-list.css',
    '../styles/pages/neon-favorecido-detail.css',
    '../styles/pages/neon-loja-list.css',
    '../styles/pages/neon-loja-detail.css',
    '../styles/pages/neon-colaborador-list.css',
    '../styles/pages/neon-colaborador-detail.css',
    '../styles/pages/neon-colaborador-comissao-list.css',
    '../styles/pages/neon-colaborador-comissao-detail.css',
    '../styles/pages/neon-contador-list.css',
    '../styles/pages/neon-contador-detail.css',
    '../styles/pages/neon-conceito-list.css',
    '../styles/pages/neon-conceito-detail.css',
    '../styles/pages/neon-faixa-renda-list.css',
    '../styles/pages/neon-faixa-renda-detail.css',
    '../styles/pages/neon-profissao-list.css',
    '../styles/pages/neon-profissao-detail.css',
    '../styles/pages/neon-ramo-atividade-list.css',
    '../styles/pages/neon-ramo-atividade-detail.css',
    '../styles/pages/neon-tipo-web-list.css',
    '../styles/pages/neon-tipo-web-detail.css',
    '../styles/pages/neon-tipo-telefone-list.css',
    '../styles/pages/neon-tipo-telefone-detail.css',
    '../styles/pages/neon-situacao-cliente-list.css',
    '../styles/pages/neon-situacao-cliente-detail.css',
    '../styles/pages/neon-credenciadora-cartao-list.css',
    '../styles/pages/neon-credenciadora-cartao-detail.css',
    '../styles/pages/neon-bandeira-cartao-list.css',
    '../styles/pages/neon-bandeira-cartao-detail.css',
    '../styles/pages/neon-contrato-list.css',
    '../styles/pages/neon-contrato-detail.css',
    '../styles/pages/neon-atualiza-status-detail.css',
    '../styles/pages/neon-custo-operacional-list.css',
    '../styles/pages/neon-custo-operacional-detail.css',
    '../styles/pages/neon-categoria-list.css',
    '../styles/pages/neon-categoria-detail.css',
    '../styles/pages/neon-marca-list.css',
    '../styles/pages/neon-marca-detail.css',
    '../styles/pages/neon-fabricante-list.css',
    '../styles/pages/neon-fabricante-detail.css',
    '../styles/pages/neon-veiculos-fabricante-list.css',
    '../styles/pages/neon-relatorio-clientes-list.css',
    '../styles/pages/neon-relatorio-compras-list.css',
    '../styles/pages/neon-relatorio-duplicata-receber-detail.css',
    '../styles/pages/neon-relatorio-duplicata-pagar-detail.css',
    '../styles/pages/neon-relatorio-fornecedores-list.css',
    '../styles/pages/neon-relatorio-produtos-list.css',
    '../styles/pages/neon-relatorio-comparar-preco-nfe-list.css',
    '../styles/pages/neon-relatorio-inventario-list.css',
    '../styles/pages/neon-relatorio-auditoria-estoque-list.css',
    '../styles/pages/neon-relatorio-etiqueta-produto-list.css',
    '../styles/pages/neon-relatorio-vendas-list.css',
    '../styles/pages/neon-relatorio-xml-vendas-list.css',
    '../styles/pages/neon-relatorio-comissao-list.css',
    '../styles/pages/neon-relatorio-plano-contas-list.css',
    '../styles/pages/neon-relatorio-lancamento-financeiro-detail.css',
    '../styles/pages/neon-relatorio-conciliacao-detail.css',
    '../styles/pages/neon-relatorio-produtos-entrada-saida-detail.css',
    '../styles/pages/neon-relatorio-produto-entrada-saida-detail.css',
    '../styles/pages/neon-relatorio-produto-estoque-data-detail.css',
    '../styles/pages/neon-relatorio-produto-endereco-list.css',
    '../styles/pages/neon-relatorio-movimentacao-plano-contas-detail.css',
    '../styles/pages/neon-importacao-xls-detail.css',
    '../styles/pages/neon-setup-detail.css',
    '../styles/pages/neon-conf-nfe-list.css',
    '../styles/pages/neon-conf-nfe-detail.css',
    '../styles/pages/neon-relatorio-contratos-list.css',
    '../styles/pages/neon-relatorio-vendas-pis-cofins-list.css',
    '../styles/pages/neon-minuta-despacho-list.css',
    '../styles/pages/neon-minuta-despacho-detail.css',
    '../styles/pages/neon-veiculos-fabricante-detail.css',
    '../styles/pages/neon-veiculos-modelo-list.css',
    '../styles/pages/neon-veiculos-modelo-detail.css',
    '../styles/pages/neon-veiculos-veiculo-list.css',
    '../styles/pages/neon-veiculos-veiculo-detail.css',
    '../styles/pages/neon-veiculos-veiculo-produto-list.css',
    '../styles/pages/neon-veiculos-veiculo-produto-detail.css',
    '../styles/pages/neon-grupo-loja-list.css',
    '../styles/pages/neon-grupo-loja-detail.css',
    '../styles/pages/neon-permissao-list.css',
    '../styles/pages/neon-permissao-detail.css',
    '../styles/pages/neon-usuario-list.css',
    '../styles/pages/neon-usuario-detail.css',
    '../styles/pages/neon-usuario-aplicativo-list.css',
    '../styles/pages/neon-unidade-list.css',
    '../styles/pages/neon-unidade-detail.css',
    '../styles/pages/neon-grupo-equivalente-list.css',
    '../styles/pages/neon-grupo-equivalente-detail.css',
    '../styles/pages/neon-lista-preco-list.css',
    '../styles/pages/neon-lista-preco-detail.css',
    '../styles/pages/neon-grade-variacao-list.css',
    '../styles/pages/neon-grade-variacao-detail.css',
    '../styles/pages/neon-grade-produto-list.css',
    '../styles/pages/neon-grade-produto-detail.css',
    '../styles/pages/neon-produto-list.css',
    '../styles/pages/neon-produto-detail.css',
    '../styles/pages/neon-atualiza-preco-detail.css',
    '../styles/pages/neon-correcao-list.css',
    '../styles/pages/neon-correcao-detail.css',
    '../styles/pages/neon-manutencao-produto-list.css',
    '../styles/pages/neon-manutencao-produto-detail.css',
    '../styles/pages/neon-gerar-balanco.css',
    '../styles/pages/neon-transferencia-lojas-list.css',
    '../styles/pages/neon-transferencia-lojas-detail.css',
    '../styles/pages/neon-confirmar-transferencia-list.css',
    '../styles/pages/neon-confirmar-transferencia-detail.css',
    '../styles/pages/neon-pedido-list.css',
    '../styles/pages/neon-pedido-detail.css',
        '../styles/pages/neon-devolucao-fornecedor.css',
        '../styles/pages/neon-devolucao-cliente.css',
    '../styles/pages/neon-pedido-compra-list.css',
    '../styles/pages/neon-pedido-compra-detail.css',
    '../styles/pages/neon-entrada-compra-list.css',
    '../styles/pages/neon-entrada-compra-detail.css',
    '../styles/pages/neon-pdv-list.css',
    '../styles/pages/neon-comanda-list.css',
    '../styles/pages/neon-altera-nfe-list.css',
    '../styles/pages/neon-altera-nfe-detail.css',
    '../styles/pages/neon-cancelamento-pedido-list.css',
    '../styles/pages/neon-cancelamento-pedido-detail.css',
    '../styles/pages/neon-cancelamento-pedido-compra-list.css',
    '../styles/pages/neon-cancelamento-pedido-compra-detail.css',
    '../styles/pages/neon-cancelamento-entrada-list.css',
    '../styles/pages/neon-cancelamento-entrada-detail.css',
    '../styles/pages/neon-importacao-compra-list.css',
    '../styles/pages/neon-importacao-compra-detail.css',
    '../styles/pages/neon-sugestao-compra.css',
    '../styles/pages/neon-carta-correcao-list.css',
    '../styles/pages/neon-carta-correcao-detail.css',
    '../styles/pages/neon-inutilizacao-nfce-nfe-list.css',
    '../styles/pages/neon-inutilizacao-nfce-nfe-detail.css',
    '../styles/pages/neon-grupo-desconto-list.css',
    '../styles/pages/neon-grupo-desconto-detail.css',
    '../styles/pages/neon-comissao-desconto-list.css',
    '../styles/pages/neon-comissao-desconto-detail.css',
    '../styles/pages/neon-grupo-tributo-produto-list.css',
    '../styles/pages/neon-grupo-tributo-produto-detail.css',
    '../styles/pages/neon-grupo-tributo-favorecido-list.css',
    '../styles/pages/neon-grupo-tributo-favorecido-detail.css',
    '../styles/pages/neon-ncm-list.css',
    '../styles/pages/neon-ncm-detail.css',
    '../styles/pages/neon-modelo-documento-fiscal-list.css',
    '../styles/pages/neon-modelo-documento-fiscal-detail.css',
    '../styles/pages/neon-cfop-list.css',
    '../styles/pages/neon-cfop-detail.css',
    '../styles/pages/neon-convenio-list.css',
    '../styles/pages/neon-convenio-detail.css',
    '../styles/pages/neon-conciliacao-econf-list.css',
    '../styles/pages/neon-conciliacao-econf-detail.css',
    '../styles/pages/neon-situacao-tributaria-list.css',
    '../styles/pages/neon-situacao-tributaria-detail.css',
    '../styles/pages/neon-configuracao-tributo-list.css',
    '../styles/pages/neon-configuracao-tributo-detail.css',
    '../styles/pages/neon-operacao-list.css',
    '../styles/pages/neon-operacao-detail.css',
    '../styles/pages/neon-sped-fiscal.css',
    '../styles/pages/neon-sped-pis-cofins.css',
    '../styles/pages/neon-transportadora-list.css',
    '../styles/pages/neon-transportadora-detail.css',
    '../styles/pages/neon-duplicata-pagar-list.css',
    '../styles/pages/neon-duplicata-pagar-detail.css',
    '../styles/pages/neon-baixa-parcela-pagar-list.css',
    '../styles/pages/neon-faturamento-boleto-list.css',
    '../styles/pages/neon-faturamento-compras-list.css',
    '../styles/pages/neon-faturamento-nota-list.css',
    '../styles/pages/neon-forma-pagamento-list.css',
    '../styles/pages/neon-forma-pagamento-detail.css',
    '../styles/pages/neon-terminal-pagamento-detail.css',
    '../styles/pages/neon-prazo-list.css',
    '../styles/pages/neon-prazo-detail.css',
    '../styles/pages/neon-pdv-pagamento-list.css',
    '../styles/pages/neon-pdv-pagamento-detail.css',
    '../styles/pages/neon-banco-list.css',
    '../styles/pages/neon-banco-detail.css',
    '../styles/pages/neon-instrucao-bancaria-list.css',
    '../styles/pages/neon-instrucao-bancaria-detail.css',
    '../styles/pages/neon-motivo-devolucao-cheque-list.css',
    '../styles/pages/neon-motivo-devolucao-cheque-detail.css',
    '../styles/pages/neon-plano-contas-list.css',
    '../styles/pages/neon-plano-contas-detail.css',
    '../styles/pages/neon-conta-list.css',
    '../styles/pages/neon-conta-detail.css',
    '../styles/pages/neon-boleto-araguaia-list.css',
    '../styles/pages/neon-lancamentos-financeiros-list.css',
    '../styles/pages/neon-lancamentos-financeiros-detail.css',
    '../styles/pages/neon-estorno-lancamento-financeiro-list.css',
    '../styles/pages/neon-estorno-lancamento-financeiro-detail.css',
    '../styles/pages/neon-transferencia-contas-list.css',
    '../styles/pages/neon-transferencia-contas-detail.css',
    '../styles/pages/neon-duplicata-receber-list.css',
    '../styles/pages/neon-duplicata-receber-detail.css',
    '../styles/pages/neon-baixa-parcela-receber-list.css',
    '../styles/pages/neon-gerar-remessa-list.css',
    '../styles/pages/neon-retorno-bancario-list.css',
    '../styles/pages/neon-retorno-bancario-detail.css',
    '../styles/pages/neon-baixar-retorno-list.css',
    '../styles/pages/neon-fechamento-conta-list.css',
    '../styles/pages/neon-fechamento-conta-detail.css',
    '../styles/pages/neon-dashboard.css'
  ],
  encapsulation: ViewEncapsulation.None
})

export class AppComponent implements OnInit, AfterViewInit {
  teste: String;
  closeSession = false;
  private pageEnter: Boolean = false;
  pagesActive: any;
  refresh: number = 0;
  refresh_ondestroy: Number;
  pagesActiveStr;
  rotaAnterior;
  rotaAtual;
  keypressCode;
  tipoObjeto: string = 'E'; //TipoObjeto.EQUIPAMENTO
  windowSize: number;
  usuarioLogado = Object();
  isSidebarCollapsed = true;
  private limitePaginas: number = 5;
  private user: string = '';
  private login = {
    login: '',
    password: ''
  };
  public setupModel: Setup = new Setup();
  public subMenus: any;
  public subMenuAnterior: any = null;
  public ultimaListaClicada: any;
  public ultimoMenuClicado: any;
  public pesquisaSistema: string = '';
  public version: string = environment.version;

  constructor(
    public _router: Router,
    public activatedRoute: ActivatedRoute,
    public _messageService: MessageService,
    public authService: AuthService,
    public _confirmationService: ConfirmationService,
    public globalsVariablesService: GlobalsVariablesService,
    public cookieService: CookieService,
    public _setupService: SetupService,
    public layoutThemeService: LayoutThemeService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
  ) {
  }

  ngOnInit() {
 

    this.abrirMenus();
    this.verificarRotas();
    this.saveCurrentRoute();
    this.buscarSubMenus();
    this.ativarBuscaMenu();
    this.removeUltimaPesquisa()

  }

  ngAfterViewInit() {
    console.log('usuario')
    console.log(this.setupModel)
    this.prepararMenuRecolhido();
    let listItens = document.querySelectorAll('li.treeview');
    listItens.forEach(element => {
      element.addEventListener( 'click', (e) => {
        setTimeout(
          () => {
            this.removeUltimaPesquisa();
            try{
              let unorderedList = element.querySelector('ul.display-block')
              let iElement = element.querySelector('i.fa-angle-right')
              if(unorderedList){
                document.querySelectorAll('i.fa-angle-down').forEach( e => {
                  //console.log(e)
                  e.classList.remove('fa-angle-down');
                } )
                iElement.classList.add('fa-angle-down')
                
              }
              else{
                iElement.classList.remove('fa-angle-down')
              }
            }
            
            catch(e){}
          }, 150
        )
      })
    });
   }

  @HostListener('window:load', ['$event'])
  onload(event) {
    this.refresh = performance.navigation.type;
    this.enter();
  }

  // Controla o painel lateral dos submenus quando o tema novo esta recolhido.
  @HostListener('document:click', ['$event'])
  public controlarFlyoutMenu(event: MouseEvent): void {
    if (!this.layoutThemeService.isNeon || !this.document.body.classList.contains('sidebar-collapse')) {
      this.fecharFlyoutsMenu();
      return;
    }

    const alvo = event.target as HTMLElement;
    const linkPrincipal = alvo.closest('.sidebar-menu > li.treeview > a') as HTMLElement;

    if (linkPrincipal) {
      const itemPrincipal = linkPrincipal.parentElement as HTMLElement;
      const submenu = this.obterSubmenuDireto(itemPrincipal);

      if (!submenu) {
        this.fecharFlyoutsMenu();
        return;
      }

      event.preventDefault();
      const estavaAberto = itemPrincipal.classList.contains('neon-flyout-open');
      this.fecharFlyoutsMenu();

      if (!estavaAberto) {
        const titulo = linkPrincipal.querySelector('span');
        submenu.setAttribute('data-neon-title', titulo ? titulo.textContent.trim() : 'Menu');
        itemPrincipal.classList.add('neon-flyout-open');
        submenu.classList.add('display-block');
        this.posicionarFlyoutMenu(linkPrincipal, submenu);
      }
      return;
    }

    if (alvo.closest('.sidebar-menu .treeview-menu a.rota')) {
      this.fecharFlyoutsMenu();
      return;
    }

    if (!alvo.closest('.main-sidebar')) {
      this.fecharFlyoutsMenu();
    }
  }


  ativarBuscaMenu() {
    const input = document.getElementById('menuSearchInput') as HTMLInputElement;
    const form = document.querySelector('.menu-search') as HTMLFormElement;

    const limparBusca = () => {
      const encontrados = document.querySelectorAll('.subMenuEncontrado, .hide');

      encontrados.forEach((item: Element) => {
        item.classList.remove('subMenuEncontrado', 'hide');

        const liPai = item.closest('.treeview') as HTMLElement;
        const ulSubmenu = item.closest('ul') as HTMLElement;

        if (liPai) liPai.classList.remove('menuAberto');
        if (ulSubmenu) ulSubmenu.classList.remove('display-block');

        const icone = liPai.querySelector('i.fa-angle-down') as HTMLElement;
        if (icone) {
          icone.classList.remove('fa-angle-down');
          icone.classList.add('fa-angle-right');
        }
      });
    };

    if (form) {
      form.addEventListener('submit', (e) => e.preventDefault());
    }

    if (input) {
      input.addEventListener('input', () => {
        const termo = input.value.trim().toLowerCase();

        if (termo.length <= 1) {
          limparBusca();
          return;
        }

        const subMenus = document.querySelectorAll('.treeview li');

        subMenus.forEach((item: Element) => {
          const texto = item.textContent.trim().toLowerCase() || '';
          const liPai = item.closest('.treeview') as HTMLElement;
          const ulSubmenu = item.closest('ul') as HTMLElement;

          if (texto.includes(termo)) {
            item.classList.add('subMenuEncontrado');
            item.classList.remove('hide');

            if (liPai) liPai.classList.add('menuAberto');
            if (ulSubmenu) ulSubmenu.classList.add('display-block');

            const icone = liPai.querySelector('i.fa-angle-right') as HTMLElement;
            if (icone) {
              icone.classList.remove('fa-angle-right');
              icone.classList.add('fa-angle-down');
            }
          } else {
            item.classList.remove('subMenuEncontrado');
            item.classList.add('hide');
          }
        });
        this.removeUltimaPesquisa();
      });

      document.addEventListener('click', (e) => {
        const alvo = e.target as HTMLElement;

        const itemClicado = alvo.closest('.subMenuEncontrado');

        if (itemClicado) {
          const liPai = itemClicado.closest('.treeview') as HTMLElement;

          input.value = '';

          limparBusca();

          if (liPai) {
            liPai.classList.add('menuAberto');

            const ulSubmenu = liPai.querySelector('ul');
            if (ulSubmenu) ulSubmenu.classList.add('display-block');

            const icone = liPai.querySelector('i.fa-angle-right') as HTMLElement;
            if (icone) {
              icone.classList.remove('fa-angle-right');
              icone.classList.add('fa-angle-down');
            }
          }

        }
      });

      input.addEventListener('blur', () => {
        const termo = input.value.trim();
        if (termo === '') {
          limparBusca();
        }
      });
    }
  }

  abrirMenus(): void {
    let interval = setInterval(
      () => {
        let arraySubMenus = document.querySelectorAll('.treeview')
        let array = Array.prototype.slice.call(arraySubMenus);

        array.forEach(elemento => {
          elemento.addEventListener('click', (evt) => {
            let elementoHTML = <HTMLElement>elemento;
            let subMenu = elementoHTML.childNodes[1] as HTMLElement;

            //Fecha SubMenu apenas se clicar no span de treview. Outros spans não devem fechar o SubMenu quando clicados.
            if (subMenu.classList.contains('display-block') && !evt.target.classList.contains('rota')) {
              subMenu.classList.remove('display-block');
              this.ultimoMenuClicado.classList.remove('display-block');
              this.ultimaListaClicada = elementoHTML;
              this.ultimoMenuClicado = subMenu;
              return;
            }


            subMenu.classList.add('display-block');

            if (this.ultimoMenuClicado == undefined)
              this.ultimoMenuClicado = subMenu;

            if (elementoHTML === this.ultimaListaClicada && subMenu.classList.contains('display-block'))
              return;

            if (elementoHTML != this.ultimaListaClicada) {
              this.ultimoMenuClicado.classList.remove('display-block');
            }

            this.ultimaListaClicada = elementoHTML;
            this.ultimoMenuClicado = subMenu;
          });
        })
        clearInterval(interval);

      },
      500
    );

  }



  private enter() {

    this.pagesActiveStr = localStorage.getItem("PagesActive");
    this.pagesActive = parseInt(this.pagesActiveStr);

    if (this.refresh != 1) {
      this.newPage();
      this.verificarAutenticacao();
      this.pageEnter = true;
    } else {
      if (this.refresh == 1) {
        this.refreshPage();
        this.pageEnter = true;
      }
    }

  }

  private newPage() {
    if (this.pagesActive == null || this.pagesActive == 0 || isNaN(this.pagesActive)) {
      //primeiro acesso - primeira aba ativa
      this.pagesActive = 1;
      this.pagesActiveStr = this.pagesActive;
      this.pagesActiveStr.toString();
      sessionStorage.setItem("firstPage", "yes");
    } else {
      //Pega o histórico de abas abertas e soma +1 para gravar a atividade da aba atual
      this.pagesActive++;
      this.pagesActiveStr = this.pagesActive.toString();
    }
    // this.limitPage(this.pagesActive);
    //atualiza o saldo de abas ativas no LOCALSTORAGE
    localStorage.setItem("PagesActive", this.pagesActive);
  }

  private refreshPage() {
    this.listarSetups();
    this.pagesActive++;
    // this.limitPage(this.pagesActive);

    if (isNaN(this.pagesActive)) {
      this.pagesActive = 1;
    }

    localStorage.setItem("PagesActive", this.pagesActive);

    //RECUPERA OS DADOS DE PERMISSAO DO USUÁRIO QUANDO DADO UM REFRESH 
    let usuarioLogado = sessionStorage.getItem("usuarioLogado");

    if (usuarioLogado != null && usuarioLogado != "{}") {
      sessionStorage.removeItem("usuarioLogado");
      localStorage.removeItem("usuarioLogado");
      //MONTANDO STORAGE COM AS PERMISSOES
      let authToken = sessionStorage.getItem("authToken");
      if (authToken != null) {
        localStorage.setItem("authToken", authToken);
        this.usuarioLogado = JSON.parse(usuarioLogado);
        this.user = this.cookieService.get('user');
        if (this.user == '') {
          this.login.login = this.usuarioLogado.login;
          this.login.password = this.usuarioLogado.senha;
          this.cookieService.set('user', JSON.stringify(this.login), 365);
        }
        this.globalsVariablesService.setGlobalsVariables(this.usuarioLogado);
      } else {
        authToken = localStorage.getItem("authToken");
        if (authToken != null) {
          sessionStorage.setItem("authToken", authToken);
          this.usuarioLogado = JSON.parse(usuarioLogado);
          this.user = this.cookieService.get('user');
          if (this.user == '') {
            this.login.login = this.usuarioLogado.login;
            this.login.password = this.usuarioLogado.senha;
            this.cookieService.set('user', JSON.stringify(this.login), 365);
          }
          this.globalsVariablesService.setGlobalsVariables(this.usuarioLogado);
        } else {
          this.resetSessao();
        }
      }
    } else {
      this.verificarAutenticacao();
    }

    //QUANDO O REFRESH FOR FEITO ATRAVÉS DO BOTÃO ATUALIZAR DA PÁGINA
    if (this.pagesActiveStr == null) {
      localStorage.setItem("PagesActive", "1");
      let rotaAnterior = this.getRoute();
      if (rotaAnterior == "/login") {
        this.resetSessao();
      } else {
        //QUANDO REFRESH FEITO EM ALGUMA OUTRA PÁGINA ATIVA
        if (rotaAnterior == null) {
          this._router.navigate(['/dashboard']);
        }
      }
    }
  }

  private verificarAutenticacao() {
    if (this.pagesActive == null || this.pagesActive == 0 || isNaN(this.pagesActive)) {
      this.pagesActive = 1;
      this.pagesActiveStr = this.pagesActive;
      this.pagesActiveStr.toString();
    }
    // this.limitPage(this.pagesActive);
    if (this.authService.isLoggedIn == false) {
      this.resetSessao();
    } else {
      if (this.globalsVariablesService.getPermissaoSuccess == false) {
        this.recuperarSessao();
      }
    }
  }

  private verificarLogin() {
    let validAuth = true;
    let auth: any = localStorage.getItem("authToken");
    if (auth == null || auth == '') validAuth = false;
    if (this._router.url == '/login') {
      if (this.authService.isLoggedIn) {
        if (this.globalsVariablesService.getPermissaoSuccess) {
          this.usuarioAutenticado();
        } else {
          this.recuperarSessao();
          this.usuarioAutenticado();
        }
      }
    } else {
      if (validAuth) this.verificarAutenticacao(); else this.resetSessao();
    }
  }

  private usuarioAutenticado() {
    // Caso entre em varias telas de login e realize o login em uma delas
    // as outras telas devem obedecer autenticação e atualizar a quantidade de páginas ativas
    // sendo o usuário redirecionado ao Dashboard.
    let pagesActive = localStorage.getItem("PagesActive");
    this.pagesActive = parseInt(pagesActive) + 1;
    // this.limitPage(this.pagesActive);
    localStorage.setItem("PagesActive", this.pagesActive.toString());
    document.querySelector('body').classList.remove('backLogin');
    this._router.navigate(['/dashboard']);
  }

  private removeUltimaPesquisa(){

    sessionStorage.removeItem("dataPesquisaInicio");
    sessionStorage.removeItem("dataPesquisaFinal");
    sessionStorage.removeItem("pesquisa");
    sessionStorage.removeItem("paginaPedidos");
    sessionStorage.removeItem("paginaComponente");
    sessionStorage.removeItem("tipoPesquisa");
    sessionStorage.removeItem("cancelado");
    sessionStorage.removeItem("qtdItensPagina");

  }

  private recuperarSessao() {
    //CASO TIVER AUTENTICAÇÃO VOLTA COM AS PERMISSÕES DO USUÁRIO
    this.user = this.cookieService.get('user');
    sessionStorage.removeItem("usuarioLogado");
    localStorage.removeItem("usuarioLogado");

    let login = JSON.parse(this.user);
    this.authService.autenticarUsuario(login).subscribe(res => {
      this.usuarioLogado = res;
      this.globalsVariablesService.setGlobalsVariables(this.usuarioLogado);
    });

  }

  private resetSessao() {
    const layoutTheme = localStorage.getItem(LayoutThemeService.STORAGE_KEY);
    sessionStorage.clear();
    localStorage.clear();
    if (layoutTheme) {
      localStorage.setItem(LayoutThemeService.STORAGE_KEY, layoutTheme);
    }
    localStorage.setItem("PagesActive", "1");
    this.cookieService.delete('user');
    this.globalsVariablesService.blockedGlobalsVariables();
    this._router.navigate(['/login']);
  }

  private logout() {
    this._confirmationService.confirm({
      message: 'Tem certeza que deseja sair do sistema ?',
      header: 'NEON ERP',
      icon: 'fa fa-power-off',
      accept: () => {
        this.resetSessao();
        this.authService.logout();
      }
    });
  }


  private saveCurrentRoute() {
    let rotaAtual = this._router.url;
    sessionStorage.setItem("rota", rotaAtual);
  }

  private getRoute() {
    return sessionStorage.getItem("rota");
  }

  // private limitPage(pages) {
  //   if (pages >= this.limitePaginas) {
  //     this._messageService.warn('Prezado(a), você atingiu o limite máximo de 4 páginas ativas. Por gentileza, não ultrapasse-o.');
  //     setTimeout(function () {
  //       location.replace("https://araguaiasistemas.com.br");
  //     }, 5000);
  //   }
  // }

  public verificarRotas() {
    this._router.events
      .subscribe((event) => {
        if (event instanceof ActivatedRoute) {
          this.rotaAtual = event.url;
          /*
          if(this.rotaAtual === "/comercial/pedido/new"){
            this.rotaAnterior = event.url;
            this.authService.setCancelRoute(true);
          }else{
            if(this.rotaAnterior === "/comercial/pedido/new"){
              if(this.rotaAtual != "/comercial/pedido"){
                this._confirmationService.confirm({
                  message: 'Atenção! Os dados serão perdidos. Deseja realmente mudar de tela ?',
                  header: 'Aviso',
                  icon: 'fa fa-exclamation-triangle',
                  accept: () => {
                    this.rotaAnterior = this.rotaAtual;
                    this.authService.setCancelRoute(false);
                    this._router.navigate([this.rotaAtual]);
                  }
                });
              }
            }
          }*/
        }
      });
  }

  public listarSetups() {
    this._setupService.getSetup().then(res => {
      this.carregarInformacoesSetup(res);
    });
  }

  public carregarInformacoesSetup(res) {
    this.globalsVariablesService.setInformacoesSetup(res);
  }

  @HostListener("window:keydown", ["$event"])
  detectKeyboard(event: KeyboardEvent) {
    if (event.keyCode == KEY_CODE.TECLA_F05) {
      this.keypressCode = event.keyCode;
    }

    if (event.keyCode === KEY_CODE.TECLA_J && event.ctrlKey == true) {
      //prevent event Crlt + J (Downloads) p/ leitores de código de barras
      event.preventDefault();
    }

    if (event.keyCode === KEY_CODE.TECLA_F12) {
      //prevent event Inspecionar Elemento p/ leitores de código de barras
      event.preventDefault();
    }
  }

  @HostListener('window:unload', ['$event'])
  unload(event) {
    //event.preventEvent(); //quando acionado o restante do código não é lido pelo navegador
    let pagesActive = parseInt(localStorage.getItem("PagesActive"));
    //só pode diminuir o número página ativa se já tiver carregado ela toda
    if (this.pageEnter) pagesActive--;
    this.pagesActive = pagesActive;
    localStorage.setItem("PagesActive", pagesActive.toString());

    //SALVA OS DADOS DE PERMISSAO DO USUÁRIO PARA QUANDO DADO UM REFRESH
    sessionStorage.setItem("usuarioLogado", JSON.stringify(this.globalsVariablesService.getUsuarioLogado));

    if (this.pagesActive <= 0) {
      if (this.keypressCode != KEY_CODE.TECLA_F05) {
        //DADOS PARA RECUPERAR EM UM EVENTO RELOAD (REFRESH DA ÚLTIMA PÁGINA)
        this.saveCurrentRoute();
        // -------------------------------------------------------------- //
        this.authService.logout();
        localStorage.clear();
      }
    }
  }

  /**
   * Fica verificando se haverá algum clique no botão SALVAR,
   * se houver, imediatamente após o click, o botão SALVAR é desabilitado
   * evitando que quando houver um delay no processo "SAVE" o usuário clique novamente
   * em salvar e salve o registro 2x
   */
  @HostListener('click', ['$event.target.classList']) onClick(event) {
    let arrClass = event;
    let result = arrClass.contains('btnSalvar');
    this.windowSize = window.innerWidth;

    if (this.windowSize < 500) {
      let mobile = arrClass.contains('rota');
      if (mobile) {
        document.querySelector('.sidebar-mini').classList.remove('sidebar-open');
      }
    }

    /* EVITA DUPLOS CLIQUES EM SALVAR
    * Retirei para que seja reativo o seu comportamento
    *  
    if(result){
      document.querySelector('.btnSalvar').setAttribute("disabled", "disabled");
    }*/

    this.verificarLogin();
  }

  public buscarSubMenus(): void {
    let interval = setInterval(() => {
      this.subMenus = document.querySelectorAll('.menuSelecionado');
      let arraySubMenus = Array.prototype.slice.call(this.subMenus);
      if (arraySubMenus.length > 20) {
        this.adicionarEventoClique(arraySubMenus);
        clearInterval(interval);
      }

    }, 2000)
  }

  public adicionarEventoClique(arraySubMenus: any[]): void {
    arraySubMenus.forEach(elemento => {
      elemento.addEventListener('click', () => {
        if (elemento == this.subMenuAnterior)
          return;

        elemento.classList.add('subMenuAtivo');
        if (this.subMenuAnterior != null)
          this.subMenuAnterior.classList.remove('subMenuAtivo');

        this.subMenuAnterior = elemento;
      });
    })
  }


  toggleAside(){
    setTimeout(() => {
      this.isSidebarCollapsed = this.document.body.classList.contains('sidebar-collapse');
      this.fecharFlyoutsMenu();
    });
  }

  // Adiciona uma descricao nativa aos icones exibidos no menu recolhido.
  private prepararMenuRecolhido(): void {
    const links = this.document.querySelectorAll('.sidebar-menu > li.treeview > a');

    links.forEach((link: Element) => {
      const titulo = link.querySelector('span');
      if (titulo && titulo.textContent) {
        link.setAttribute('title', titulo.textContent.trim());
      }
    });
  }

  // Retorna apenas o submenu pertencente diretamente ao item principal.
  private obterSubmenuDireto(itemPrincipal: HTMLElement): HTMLElement {
    const filhos = Array.prototype.slice.call(itemPrincipal.children) as HTMLElement[];
    return filhos.find(filho => filho.classList.contains('treeview-menu')) || null;
  }

  // Posiciona o painel dentro da area visivel mesmo nos itens inferiores do menu.
  private posicionarFlyoutMenu(linkPrincipal: HTMLElement, submenu: HTMLElement): void {
    submenu.style.top = '84px';

    setTimeout(() => {
      const margem = 16;
      const topoMinimo = 84;
      const limiteAltura = window.innerHeight - topoMinimo - margem;
      const alturaPainel = Math.min(submenu.scrollHeight, limiteAltura);
      const topoItem = linkPrincipal.getBoundingClientRect().top;
      const topoMaximo = window.innerHeight - alturaPainel - margem;
      const topo = Math.max(topoMinimo, Math.min(topoItem, topoMaximo));

      submenu.style.top = topo + 'px';
      submenu.style.maxHeight = limiteAltura + 'px';
    });
  }

  // Fecha qualquer submenu flutuante aberto e remove estados deixados pelo menu antigo.
  private fecharFlyoutsMenu(): void {
    const itensAbertos = this.document.querySelectorAll('.sidebar-menu > li.neon-flyout-open');

    itensAbertos.forEach((item: Element) => {
      item.classList.remove('neon-flyout-open');
      const submenu = this.obterSubmenuDireto(item as HTMLElement);

      if (submenu) {
        submenu.classList.remove('display-block');
        submenu.style.removeProperty('top');
        submenu.style.removeProperty('max-height');
      }
    });
  }

  // Reaproveita a busca do menu lateral no campo de busca do cabecalho moderno.
  public pesquisarNoSistema(valor: string): void {
    const input = this.document.getElementById('menuSearchInput') as HTMLInputElement;
    if (!input) {
      return;
    }

    input.value = valor || '';
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  // Retorna um titulo simples conforme o modulo da rota atual.
  public get tituloPaginaAtual(): string {
    const rota = (this._router.url || '').split('?')[0];
    const modulo = rota.split('/')[1] || 'dashboard';
    const titulos = {
      dashboard: 'Dashboard',
      administrativo: 'Administrativo',
      comercial: 'Comercial',
      estoque: 'Estoque',
      financeiro: 'Financeiro',
      fiscal: 'Fiscal',
      relatorios: 'Relatorios',
      configuracoes: 'Configuracoes',
      seguranca: 'Seguranca',
      equipamentos: 'Equipamentos',
      veiculos: 'Veiculos',
      utilitarios: 'Utilitarios'
    };

    return titulos[modulo] || 'Neon ERP';
  }


}
